<template>
  <div class="action-icons">
    <toggle-box ref="actionBtn" class="action-icon">
      <template v-slot:control>
        <div
          :class="{
            unclaimend: step === ORDER_STEP.UNCLAIMED,
            contact: step === ORDER_STEP.CONTACT,
            pending: step === ORDER_STEP.PENDING,
            appointment: step === ORDER_STEP.APPOINTMENT,
            quoted: step === ORDER_STEP.QUOTED,
            contract: step === ORDER_STEP.CONTRACT,
            coldlead: step === ORDER_STEP.COLD_LEAD,
            warmlead: step === ORDER_STEP.WARM_LEAD
          }"
          @click="() => (step === ORDER_STEP.UNCLAIMED) ? onClaimOrder(orderId) : showStageList()"
        >
          <font-awesome-icon :icon="getIconFromStep(step)" />
        </div>
      </template>
      <template v-slot:content>
        <ul>
          <div class="text">
            <li v-for="(stage, index) in getListStages" :key="index" @click="() => toggleOffBtn(stage, orderId)">
              {{ $t(getKeyStageTranslations(stage)) }}
            </li>
          </div>
        </ul>
      </template>
    </toggle-box>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faReply,
  faIdBadge,
  faSync,
  faCalendarMinus,
  faBed,
  faClipboardCheck,
  faParachuteBox
} from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { ORDER_STEP } from '@/consts';

import ToggleBox from '@/components/ToggleBox';

export default {
  name: 'ActionIcon',
  components: {
    FontAwesomeIcon,
    ToggleBox,
  },

  props: {
    step: String,
    stage: String,
    status: String,
    orderId: Number,
    getListStages: Array,
    onHandleUpdateOrderStage: Function,
    getclaimOrder: Function,
    getKeyStageTranslations: Function
  },

  setup(props, { refs }) {
    const { onHandleUpdateOrderStage, getclaimOrder } = props;
    const showStageList = () => {
      refs.actionBtn.toggle();
    };

    const toggleOffBtn = (stage, id) => {
      onHandleUpdateOrderStage(stage, id);
      refs.actionBtn.toggle(false);
    };

    const onClaimOrder = (id) => {
      getclaimOrder(id);
    };

    const getIconFromStep = (step) => {
      if (step === ORDER_STEP.UNCLAIMED) {
        const icon = faReply;
        return icon;
      }
      if (step === ORDER_STEP.CONTACT) {
        const icon = faIdBadge;
        return icon;
      }
      if (step === ORDER_STEP.PENDING) {
        const icon = faCheckCircle;
        return icon;
      }
      if (step === ORDER_STEP.APPOINTMENT) {
        const icon = faCalendarMinus;
        return icon;
      }
      if (step === ORDER_STEP.QUOTED) {
        const icon = faSync;
        return icon;
      }
      if (step === ORDER_STEP.CONTRACT) {
        const icon = faClipboardCheck;
        return icon;
      }
      if (step === ORDER_STEP.COLD_LEAD) {
        const icon = faBed;
        return icon;
      }
      if (step === ORDER_STEP.WARM_LEAD) {
        const icon = faParachuteBox;
        return icon;
      }
      return null;
    };

    return {
      faReply,
      faIdBadge,
      faSync,
      faCalendarMinus,
      faBed,
      faClipboardCheck,
      faParachuteBox,
      faCheckCircle,
      ORDER_STEP,
      showStageList,
      toggleOffBtn,
      onClaimOrder,
      getIconFromStep
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";
.action-icons {
  display: inline-block;

  .action-icon {
    width: 32px;
    height: 32px;
    text-align: center;
    position: relative;
    cursor: pointer;
    transition: all .2s ease-in-out;
    margin: 0 5px;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: $alto;
      border-radius: 50%;
      opacity: .2;
      transition: all .2s ease-in-out;
    }
    svg {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }

    &:hover {
      &::before {
        opacity: 1;
      }

      svg {
        color: $aoEnglish;
      }
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      width: 310px;

      li {
        padding: 5px 20px;
        background-color: $babyPowder;
        cursor: pointer;
        transition: all .2s ease-in-out;
        text-align: center;
        &:hover {
              background-color: $ghostWhite;
        }
      }
    }
  }
}

</style>
